<template>
  <div class="database-table a-card">
    <virtual-scroll-wrapper
      :headers="headers"
      :list="rows"
      emptyMessage="No Routes Found"
      :count="count"
      :colspan="colspan"
      :loading="loading"
      :height="height"
      :selectOnly="selectOnly"
    >
      <template v-slot:default="{ item, colwidth }">
        <tr
          class="database-row color-alt canclick"
          :class="{ 'primary--text grey lighten-2': item.id === selected.id }"
          style="display: flex"
          @click="onclick(item)"
        >
          <div v-if="selectOnly" v-col-adjwidth="0" style="display: inline-flex; align-items: center">
            <input type="checkbox" :checked="item.id === selected.id" />
          </div>
          <td class="caption" v-col-adjwidth="'Label'" style="display: inline-flex; align-items: center">
            <a-truncate :text="formatLabel(item)" />
          </td>
          <td class="caption" v-col-adjwidth="'City Start'" style="display: inline-flex; align-items: center">
            <a-truncate :text="item.city_start" />
          </td>
          <td class="caption" v-col-adjwidth="'City End'" style="display: inline-flex; align-items: center">
            <a-truncate :text="item.city_end" />
          </td>
          <td class="caption" v-col-adjwidth="'Distance'" style="display: inline-flex; align-items: center">
            <a-truncate :text="formatDistance(item.distance)" />
          </td>
          <td class="caption" v-col-adjwidth="'Travel time'" style="display: inline-flex; align-items: center">
            <a-truncate :text="item.travel_time" />
          </td>
          <td class="caption" v-col-adjwidth="'Vias'" style="display: inline-flex; align-items: center">
            <a-truncate :text="formatVias(item.vias)" />
          </td>
          <td class="caption" v-col-adjwidth="'Description'" style="display: inline-flex; align-items: center">
            <a-truncate :text="item.description" />
          </td>
        </tr>
      </template>
    </virtual-scroll-wrapper>
  </div>
</template>

<script>
import { formatRouteVias, formatRouteLabel } from "@/modules/routes";

export default {
  props: {
    query: Object,
    selectOnly: Boolean,
    height: String,
  },
  data() {
    return {
      headers: [
        { text: "Label", value: "label" },
        { text: "City Start", value: "city_start" },
        { text: "City End", value: "city_end" },
        { text: "Distance", value: "distance" },
        { text: "Travel time", value: "travel_time" },
        { text: "Vias", value: "vias" },
        { text: "Description", value: "description" },
      ],
      selected: {},
      rows: [],
      loading: true,
      page: 0,
      queryActive: false,
      count: 0,
    };
  },
  watch: {
    query(searchQuery) {
      this.launchQueryLoop(searchQuery);
    },
  },
  computed: {
    colspan() {
      return this.selectOnly ? 8 : 7;
    },
  },
  methods: {
    formatVias(vias) {
      return formatRouteVias(vias);
    },
    formatLabel(item) {
      return formatRouteLabel(item);
    },
    formatDistance(distance) {
      if (distance == null || distance === "") return "";
      return `${distance} km`;
    },
    onclick(item) {
      if (this.selectOnly) {
        this.selected = item;
        this.$emit("select", this.selected);
        return;
      }
      this.goToPage(item);
    },
    goToPage(item) {
      this.$router.push({
        name: "route_info",
        params: { id: item.id },
      });
    },
    launchQueryLoop() {
      if (this.queryActive) return;

      this.queryActive = true;
      this.rows = [];
      this.page = 0;
      this.selected = {};
      this.loading = true;

      this.getDataCount(this.query);

      this._queryLoop(this.query)
        .then((data) => {
          this.queryActive = false;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$root.$error(err);
        });
    },
    _queryLoop(searchQuery) {
      return new Promise((resolve, reject) => {
        this._queryDatabase(this.query)
          .then((data) => {
            if (!data.rows.length) return resolve();
            this.rows.push(...data.rows);
            if (!data.continue) return resolve();
            this.page += 1;
            return this._queryLoop(this.query).then(resolve);
          })
          .catch((err) => reject(err));
      });
    },
    _queryDatabase(searchQuery) {
      return this.$store
        .dispatch("RouteStore/getRouteList", {
          query: { ...searchQuery },
          page: this.page,
        })
        .then((rows) => {
          if (!rows || !rows.length) return { rows: [], continue: false };
          return { rows, continue: rows.length === 50 };
        })
        .catch((err) => {
          this.$root.$error(err);
        });
    },
    getDataCount(searchQuery) {
      this.$store
        .dispatch("RouteStore/getRouteCount", {
          query: searchQuery,
          page: this.page,
        })
        .then((count) => {
          this.count = count;
        })
        .catch((err) => {
          this.$root.$error(err);
        });
    },
  },
  mounted() {
    this.launchQueryLoop(this.query);
  },
};
</script>
